import store from '../store';
import { signedIn, signedOut } from '../store/auth';

const CLIENT_ID = '784814268501-qimfueq2ru8ducmvomcdlap34hnm3vv9.apps.googleusercontent.com';
const API_KEY = 'AIzaSyBE-8RSFZG_82jJlcsZfxNlCAmvsDtYHbw';

// Authorization scopes required by the API; multiple scopes can be
// included, separated by spaces.
const SCOPES = 'https://www.googleapis.com/auth/calendar';

// Array of API discovery doc URLs for APIs used by the quickstart
const DISCOVERY_DOCS = ['https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest'];

/**
 *  Called when the signed in status changes, to update the UI
 *  appropriately. After a sign-in, the API is called.
 */
function updateSigninStatus(isSignedIn) {
  if (isSignedIn) {
    store.dispatch(signedIn({
      profileUrl: gapi.auth2.getAuthInstance().currentUser.get().getBasicProfile().getImageUrl(),
    }));
  } else {
    store.dispatch(signedOut());
  }
}

/**
 *  Initializes the API client library and sets up sign-in state
 *  listeners.
 */
function initClient() {
  gapi.client.init({
    apiKey: API_KEY,
    clientId: CLIENT_ID,
    discoveryDocs: DISCOVERY_DOCS,
    scope: SCOPES,
  }).then(() => {
    // Listen for sign-in state changes.
    gapi.auth2.getAuthInstance().isSignedIn.listen(updateSigninStatus);

    // Handle the initial sign-in state.
    updateSigninStatus(gapi.auth2.getAuthInstance().isSignedIn.get());
  });
}

/**
 *  On load, called to load the auth2 library and API client library.
 */
function handleClientLoad() {
  gapi.load('client:auth2', initClient);
}

function authenticate() {
  handleClientLoad();
}

export default authenticate;
